export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";

export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAILED = "REGISTER_FAILED";

export const LOGIN_REQUEST = "LOGIN_REQUESTED";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";

export const RETRIEVE_ACCOUNT_REQUEST = "RETRIEVE_ACCOUNT_REQUEST";
export const RETRIEVE_ACCOUNT_SUCCESS = "RETRIEVE_ACCOUNT_SUCCESS";
export const RETRIEVE_ACCOUNT_FAILED = "RETRIEVE_ACCOUNT_FAILED";

export const POST_ACCOUNT_REQUEST = "POST_ACCOUNT_REQUEST";
export const POST_ACCOUNT_SUCCESS = "POST_ACCOUNT_SUCCESS";
export const POST_ACCOUNT_FAILED = "POST_ACCOUNT_FAILED";

export const NOMINEE_REQUEST = "NOMINEE_REQUESTED";
export const NOMINEE_SUCCESS = "NOMINEE_SUCCESS";
export const NOMINEE_FAILED = "NOMINEE_FAILED";

export const LOGOUT = "LOGOUT";
